import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchCaptcha } from "./loginAPI";

export interface LoginState {
  captcha: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: LoginState = {
  captcha: {},
  status: "idle",
};

// export const GetCaptcha = createAsyncThunk(
//   "logIn/getcaptcha",
//   async () => {
//     const response = await fetchCaptcha();
//     return response;
//   }
// );
export const GetCaptcha = createAsyncThunk("user/fetchHomeData", async () => {
  const response = await fetchCaptcha();
  return response;
});
export const captchaSlice = createSlice({
  name: "captcha",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCaptcha.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetCaptcha.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetCaptcha.fulfilled, (state, action) => {
        state.status = "success";
        state.captcha = action.payload.captcha;
      });
  },
});

export const {} = captchaSlice.actions;

export const selectCaptcha = (state: RootState) => {
  return state.getCaptcha.captcha;
};

export default captchaSlice.reducer;
